import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

type TCybleStyledImg = {
  imgwidth?: string;
  imgheight?: string;
  objectFit?: string;
};

type TLoadingContainer = {
  height?: string;
};
type TStyledColumn = {
  pointerEvents?: string;
};

type TDragComponent = {
  width: string;
  paddingTop: string;
  height: string;
  borderWidth: string;
  margin: string;
  position?: string;
  id?: string;
  display?: string;
};
type TDragMoveDiv = {
  opacity: number;
  transform: string;
  transition: string;
};
interface RosiComponentProps {
  isDragging: boolean;
}
export const inputStyle = {
  backgroundColor: 'var(--input-box-color)',
  color: 'var(--muted-font-color)',
  cursor: 'pointer',
  fontSize: '0.875rem',
};

export const Overlapstyles = {
  // Fixes the overlapping problem of the component
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    ...inputStyle,
    textAlign: 'left',
    borderRadius: '6px !important',
    border: state.isFocused ? 'none' : '1px solid var(--border-color)',
    outline: 'none',
  }),
  valueContainer: (baseStyles: any, state: any) => ({
    ...baseStyles,
    height: '2.25rem',
    textAlign: 'left',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.5rem',
      height: '0.5rem',
      zIndex: 2,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--entityonboarding-text-color)',
      borderRadius: '0.25rem',
    },
  }),
  menuList: (provided: any) => ({
    ...provided,
    width: '100%',
    textAlign: 'left',
    overflowX: 'hidden',
    whitespace: 'normal',
    borderRadius: '6px !important',

    '&::-webkit-scrollbar': {
      width: '0.5rem',
      height: '0.5rem',
      zIndex: 2,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'var(--entityonboarding-text-color)',
      borderRadius: '0.25rem',
    },
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 9999,
    width: '100%',
    ...inputStyle,
    textAlign: 'left',
    border: '1px solid var(--border-color)',
    borderRadius: '6px !important',
    backgroundColor: 'var(--input-box-color)',
    boxShadow: 'none',
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  input: (baseStyles: any, state: any) => ({
    ...baseStyles,
    color: state.itemScope
      ? 'var(--entityonboarding-text-color)'
      : 'var(--entityonboarding-text-color)',
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    ...inputStyle,
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    fontSize: '0.65rem',
  }),
  option: (baseStyles: any, state: any) => ({
    ...baseStyles,
    overflow: 'hidden',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    backgroundColor: state.isSelected
      ? 'var(--primary-color)'
      : 'var(--input-box-color)',
    width: '100%',
    color: state.isSelected
      ? 'var(--primary-foreground)'
      : 'var(--entityonboarding-text-color)',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'var(--primary-color)',
      color: 'var(--primary-foreground)',
    },
    '&:active': {
      backgroundColor: state.isSelected ? 'var(--primary-color)' : '',
    },
  }),
};

// Fixes the overlapping problem of the component

export const theme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: 'var(--entityonboarding-text-color)',
    primary: 'var(--entityonboarding-text-color)',
  },
});

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .bgImg {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
  }
`;

export const CybleLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  top: 0;
  left: 0;
  position: absolute;
  margin: 1.5625rem;
  margin-left: 0.5rem;
  flex-direction: column;
`;

export const RightsLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  bottom: 0;
  left: 0;
  position: absolute;
  margin: 1.5625rem;
  flex-direction: column;
`;

export const CustomCardContainer = styled.div`
  top: 0;
  position: absolute;
  color: white;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  flex-direction: column;
  flex: 1;
`;

export const CustomCard = styled.div`
  display: flex;
  justify-content: center;

  border-radius: 1.25rem;
  background: rgba(0, 0, 0, 0.8);
  max-width: 32.375rem;
  height: 29.6875rem;
  flex-direction: column;
  padding: 2rem;
  margin: 1rem;
`;
export const CustomHeading = styled.h1`
  font-size: 2rem;
  margin: 25px;
`;

export const LoadingContainer = styled.div<TLoadingContainer>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: ${(props) => props.height || '80vh'};
`;
export const DateRangeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const CybleStyledImg = styled.img<TCybleStyledImg>`
  height: ${(props) => props.imgheight};
  width: ${(props) => props.imgwidth};
  object-fit: ${(props) => props.objectFit};
`;

export const StyledErrorTag = styled.p`
  color: red;
  font-size: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const StyledColumn = styled(Col)<TStyledColumn>`
  padding: 5px;
  pointer-events: ${(props) => props.pointerEvents};
`;

export const AddEditPerspectiveColumn = styled(Col)`
  width: 100%;
  @media screen and (min-width: 600px) {
    width: 14.5rem;
  }
`;

export const GeneralDashboardContainerMain = styled.div`
  height: 100%;
  min-height: 40rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-left: 1.5rem;
`;
export const OEIPageRow = styled(Row)`
  height: 100%;
  min-height: 40rem;
  margin-top: 0.5rem;
`;

export const DragComponent = styled.div<TDragComponent>`
  width: ${(props) => props.width};
  padding-top: ${(props) => props.paddingTop};
  height: ${(props) => props.height};
  border-width: ${(props) => props.borderWidth};
  margin: ${(props) => props.margin};
  position: ${(props) => props.position};
  display: ${(props) => props.display};
`;

export const DragMoveDiv = styled.div<TDragMoveDiv>`
  opacity: ${(props) => props.opacity};
  transform: ${(props) => props.transform};
  transition: ${(props) => props.transition};
`;

export const DragMoveAbsoluteDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;
export const DragInsightDiv = styled.div`
  position: absolute;
  top: 0;
  z-index: 1;
  height: 40px;
  width: 80%;
  cursor: move;
`;
export const DragOEIDiv = styled.div`
  position: absolute;
  background-color: transparent;
  height: 10%;
  width: 80%;
  z-index: 1;
  cursor: move;
`;
export const DragOEIHozDiv = styled.div`
  position: absolute;
  background-color: transparent;
  height: 10%;
  width: 60%;
  z-index: 1;
  cursor: move;
`;
export const DragRosiRiskDiv = styled.div`
  position: absolute;
  top: 0;
  z-index: 1;
  height: 40px;
  width: 80%;
  cursor: move;
`;

export const DragCSWDiv = styled.div<RosiComponentProps>`
  z-index: 1;
  height: 100%;
  width: 95%;
  cursor: ${({ isDragging }) => (isDragging ? 'move' : 'default')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
`;

export const IncidentDetailsStyledIcon = styled.i`
  color: ${(props) => props.color};
`;

export const InsightPageGridCol = styled(Col)`
  padding: 0 0.3rem 0 0.25rem;
`;
export const RosiRiskDragComponent = styled.div<RosiComponentProps>`
  opacity: ${({ isDragging }) => (isDragging ? 1 : 1)};
  transform: ${({ isDragging }) => (isDragging ? 'scale(1.05)' : 'scale(1)')};
  transition: all 0.2s;
`;
export const CSWDragComponent = styled.div<RosiComponentProps>`
  opacity: ${({ isDragging }) => (isDragging ? 1 : 1)};
  transform: ${({ isDragging }) => (isDragging ? 'scale(0.99)' : 'scale(1)')};
  transition: all 0.2s;
  height: 100%;
  border-radius: 8px;
  padding: 0.25rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-color);
  background-color: var(--card-bg-color);
  gap: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: var(--font-color);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  button:hover {
    opacity: 0.8;
  }

  button:disabled,
  button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
export const RosiRiskDragItemContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;

// SidebarStyles.js
export const SidebarContainer = styled.div<{ collapsed?: boolean }>`
  --sidebar-transition-duration: 400ms;
  width: ${({ collapsed }) => (collapsed ? '3rem' : '16rem')};
  background-color: var(--sidebar-bg-color);
  color: #ffffff;
  transition: width var(--sidebar-transition-duration)
    cubic-bezier(0.4, 0, 0.2, 1);
  height: 100vh;
  padding-top: 0.5rem;
  position: fixed;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const MenuItem = styled.div<{
  collapsed?: boolean;
  companyLogo?: boolean;
  animating?: boolean;
}>`
  border-radius: 0.25rem;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
      props.companyLogo ? '' : 'var(--sidebar-active-color)'};
    // color: ${(props) => (props.companyLogo ? '' : 'var(--primary-color)')};
    color: ${(props) => (props.companyLogo ? '' : 'var(--sidebar-bg-color)')};
    transform: ${(props) => (props.companyLogo ? 'none' : 'translateX(2px)')};
  }

  span.label {
    display: ${(props) => (props.collapsed ? 'none' : 'inline-block')};
    transition: opacity 0.3s ease;
    opacity: ${(props) => (props.collapsed ? 0 : 1)};
    white-space: nowrap;
    overflow: hidden;
  }

  justify-content: ${({ collapsed, animating }) =>
    collapsed && !animating ? 'center' : 'flex-start'};
`;

export const SubMenuContainer = styled.div<{
  collapsed?: boolean;
  isOpen?: boolean;
}>`
  margin-left: 1.75rem;
  padding-left: 0.45rem;
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.collapsed ? '0px' : '0.5rem')};
  overflow: hidden;

  /* Animate expand/collapse */
  max-height: ${(props) => (props.isOpen ? '500px' : '0')};
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  transition:
    max-height 0.4s ease,
    opacity 0.3s ease;
`;

export const SubMenuItem = styled.div<{
  animating?: boolean;
  collapsed?: boolean;
}>`
  color: var(--sidebar-active-color);
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.3s ease;
  width: 95%;
  justify-content: ${({ collapsed, animating }) =>
    collapsed && !animating ? 'center' : 'flex-start'};
  display: flex; /* ensure justify-content applies */
  align-items: center;
  margin-top: 0.5rem;

  &:hover {
    background-color: var(--sidebar-active-color);
    color: var(--sidebar-bg-color);
    transform: translateX(3px);
  }
`;

export const MenuGroup = styled.div<{ isOpen: boolean }>`
  padding: 0.25rem;
  position: relative;
  transition: all 0.4s ease;

  &::before {
    content: '';
    position: absolute;
    top: 2.5rem;
    left: 1.45rem;
    width: 1px;
    height: calc(100% - 2.5rem);
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    background-color: var(--sidebar-active-color);
    transition: opacity 0.4s ease;
  }
`;

export const ToggleSidebarSpan = styled.span<{ collapsed?: boolean }>`
  opacity: ${(props) => (props.collapsed ? 0 : 1)};
  visibility: ${(props) => (props.collapsed ? 'hidden' : 'visible')};
  transition: opacity 0.3s ease;
  white-space: nowrap';
  overflow: hidden;
  flex: ;
`;
